<template>
	<base-crud-page-read
		v-if="can('DEPARTMENT_READ')"
		:title-name="titleName"
		:title-table="$tc('menu.staff', 1)"
		:back-url="{ name: 'mainDepartmentsList' }"
	>
		<template #table v-if="Object.keys(model).length > 0">

			<table class="table az_crud_read_tb">
				<tbody>
				<tr>
					<th>{{ $t('id') }}</th>
					<td>{{ id }}</td>
				</tr>
				<tr>
					<th>{{ $tc('menu.user', 2) }}</th>
					<td>
						<ul class="az_crud_read_tb_ls">
							<li :key="item.id" v-for="item in model.employeesDtos">
								<span class="txt">
									{{item.fullName}}
								</span>

								<i class="fa fa-user-secret ml-2" v-if="item.chief" :title="$t('teamLeader')"></i>
							</li>
						</ul>
					</td>
				</tr>
				</tbody>
			</table>

		</template>
	</base-crud-page-read>
</template>

<script>
import BaseCrudPageRead from '@/components/BaseCrudPageRead';


export default {
	name: 'TeamsRead',
	components: {
		BaseCrudPageRead,
	},
	props: {
		id: {
			type: [Number, String],
		}
	},
	data()
	{
		return {
			model: {},
			titleName: '',
		};
	},
	created()
	{
		this.getOne();
	},
	methods: {
		getOne()
		{
			this.$api
				.get(`department/employees/${this.id}`)
				.then(response => {
					this.model = response.data.data
					this.titleName = response.data.data.name
					this.$store.state.metaData.title = this.$route.meta.title(response.data.data.name);
				});
		},
	}
};
</script>
